import React from 'react';
import './UILogo.css';

const UILogo = ({ ...children }) => (
  <h3 className="UI-logo__duzz-commercial" style={{ fontSize: children.size }}>
    <span style={{ fontSize: children.size }}>{children.name}</span>
    {children.lastName}
  </h3>
);

export default UILogo;
